import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { isThrottlingError } from "@smithy/service-error-classification";
export var DefaultRateLimiter = /*#__PURE__*/function () {
  function DefaultRateLimiter(options) {
    var _options$beta, _options$minCapacity, _options$minFillRate, _options$scaleConstan, _options$smooth;
    _classCallCheck(this, DefaultRateLimiter);
    this.currentCapacity = 0;
    this.enabled = false;
    this.lastMaxRate = 0;
    this.measuredTxRate = 0;
    this.requestCount = 0;
    this.lastTimestamp = 0;
    this.timeWindow = 0;
    this.beta = (_options$beta = options === null || options === void 0 ? void 0 : options.beta) !== null && _options$beta !== void 0 ? _options$beta : 0.7;
    this.minCapacity = (_options$minCapacity = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _options$minCapacity !== void 0 ? _options$minCapacity : 1;
    this.minFillRate = (_options$minFillRate = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _options$minFillRate !== void 0 ? _options$minFillRate : 0.5;
    this.scaleConstant = (_options$scaleConstan = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _options$scaleConstan !== void 0 ? _options$scaleConstan : 0.4;
    this.smooth = (_options$smooth = options === null || options === void 0 ? void 0 : options.smooth) !== null && _options$smooth !== void 0 ? _options$smooth : 0.8;
    var currentTimeInSeconds = this.getCurrentTimeInSeconds();
    this.lastThrottleTime = currentTimeInSeconds;
    this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
    this.fillRate = this.minFillRate;
    this.maxCapacity = this.minCapacity;
  }
  _createClass(DefaultRateLimiter, [{
    key: "getCurrentTimeInSeconds",
    value: function getCurrentTimeInSeconds() {
      return Date.now() / 1000;
    }
  }, {
    key: "getSendToken",
    value: function () {
      var _getSendToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.acquireTokenBucket(1));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getSendToken() {
        return _getSendToken.apply(this, arguments);
      }
      return getSendToken;
    }()
  }, {
    key: "acquireTokenBucket",
    value: function () {
      var _acquireTokenBucket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(amount) {
        var delay;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.enabled) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                this.refillTokenBucket();
                if (!(amount > this.currentCapacity)) {
                  _context2.next = 7;
                  break;
                }
                delay = (amount - this.currentCapacity) / this.fillRate * 1000;
                _context2.next = 7;
                return new Promise(function (resolve) {
                  return DefaultRateLimiter.setTimeoutFn(resolve, delay);
                });
              case 7:
                this.currentCapacity = this.currentCapacity - amount;
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function acquireTokenBucket(_x) {
        return _acquireTokenBucket.apply(this, arguments);
      }
      return acquireTokenBucket;
    }()
  }, {
    key: "refillTokenBucket",
    value: function refillTokenBucket() {
      var timestamp = this.getCurrentTimeInSeconds();
      if (!this.lastTimestamp) {
        this.lastTimestamp = timestamp;
        return;
      }
      var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
      this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
      this.lastTimestamp = timestamp;
    }
  }, {
    key: "updateClientSendingRate",
    value: function updateClientSendingRate(response) {
      var calculatedRate;
      this.updateMeasuredRate();
      if (isThrottlingError(response)) {
        var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
        this.lastMaxRate = rateToUse;
        this.calculateTimeWindow();
        this.lastThrottleTime = this.getCurrentTimeInSeconds();
        calculatedRate = this.cubicThrottle(rateToUse);
        this.enableTokenBucket();
      } else {
        this.calculateTimeWindow();
        calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
      }
      var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
      this.updateTokenBucketRate(newRate);
    }
  }, {
    key: "calculateTimeWindow",
    value: function calculateTimeWindow() {
      this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    }
  }, {
    key: "cubicThrottle",
    value: function cubicThrottle(rateToUse) {
      return this.getPrecise(rateToUse * this.beta);
    }
  }, {
    key: "cubicSuccess",
    value: function cubicSuccess(timestamp) {
      return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
  }, {
    key: "enableTokenBucket",
    value: function enableTokenBucket() {
      this.enabled = true;
    }
  }, {
    key: "updateTokenBucketRate",
    value: function updateTokenBucketRate(newRate) {
      this.refillTokenBucket();
      this.fillRate = Math.max(newRate, this.minFillRate);
      this.maxCapacity = Math.max(newRate, this.minCapacity);
      this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
  }, {
    key: "updateMeasuredRate",
    value: function updateMeasuredRate() {
      var t = this.getCurrentTimeInSeconds();
      var timeBucket = Math.floor(t * 2) / 2;
      this.requestCount++;
      if (timeBucket > this.lastTxRateBucket) {
        var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
        this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
        this.requestCount = 0;
        this.lastTxRateBucket = timeBucket;
      }
    }
  }, {
    key: "getPrecise",
    value: function getPrecise(num) {
      return parseFloat(num.toFixed(8));
    }
  }]);
  return DefaultRateLimiter;
}();
DefaultRateLimiter.setTimeoutFn = setTimeout;